export default "__VITE_ASSET__CNOa_w5___"